import apiClient from "QueryClient/axiosClient";

export const getBlogsByCategory = async (category) => {
  const response = await apiClient.get(`/blogs/category/${category}`);
  return response.data;
};

export const getBlogById = async (id) => {
  const response = await apiClient.get(`/blogs/post/${id}`);
  return response.data;
};
